(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-image-sequence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-image-sequence')) {
    customElements.define(
      'scroll-image-sequence',
      class ScrollImageSequence extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.canvas = this.querySelector('canvas');
          this.context = this.canvas.getContext('2d');
          this.frameCount = Number(this.dataset.frameCount);
          this.firstFrameUrl = this.dataset.firstFrame;
          this.fit = this.dataset.fit;
          this.frames = Array.from({ length: this.frameCount }, () => new Image());
          this.loaded = new Set();
          this.targetFrame = 0;
          this.drawnFrame = -1;
          this.ticking = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.loadFrame(0, true);
          this.handleResize();
          this.handleScroll();
          window.addEventListener('resize', this.handleResize, { passive: true });
          if (!this.reducedMotion) {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
          }
          const preload = () => {
            for (let index = 1; index < this.frameCount; index += 1) {
              this.loadFrame(index, false);
            }
          };
          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(preload, { timeout: 1200 });
          } else {
            window.setTimeout(preload, 250);
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          window.removeEventListener('scroll', this.handleScroll);
          this.initialized = false;
        }

        frameUrl(index) {
          const filename = `${String(index + 1).padStart(5, '0')}.jpg`;
          return this.firstFrameUrl.replace(/00001\.jpg(?=([?#]|$))/, filename);
        }

        loadFrame(index, highPriority) {
          const image = this.frames[index];
          if (image.src) return;
          image.decoding = 'async';
          if (highPriority) image.fetchPriority = 'high';
          image.onload = () => {
            this.loaded.add(index);
            if (index === this.targetFrame || this.drawnFrame < 0) this.requestDraw();
          };
          image.src = this.frameUrl(index);
        }

        handleScroll() {
          if (this.ticking) return;
          this.ticking = true;
          window.requestAnimationFrame(() => {
            const rect = this.getBoundingClientRect();
            const distance = Math.max(this.offsetHeight - window.innerHeight, 1);
            const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
            this.targetFrame = this.reducedMotion
              ? 0
              : Math.round(progress * (this.frameCount - 1));
            this.loadFrame(this.targetFrame, true);
            this.requestDraw();
            this.ticking = false;
          });
        }

        handleResize() {
          const rect = this.canvas.getBoundingClientRect();
          const ratio = Math.min(window.devicePixelRatio || 1, 2);
          const width = Math.max(Math.round(rect.width * ratio), 1);
          const height = Math.max(Math.round(rect.height * ratio), 1);
          if (this.canvas.width !== width || this.canvas.height !== height) {
            this.canvas.width = width;
            this.canvas.height = height;
            this.drawnFrame = -1;
          }
          this.requestDraw();
          this.handleScroll();
        }

        requestDraw() {
          window.requestAnimationFrame(() => this.draw());
        }

        draw() {
          let frameIndex = this.targetFrame;
          if (!this.loaded.has(frameIndex)) {
            const available = Array.from(this.loaded);
            if (!available.length) return;
            frameIndex = available.reduce((closest, current) =>
              Math.abs(current - this.targetFrame) < Math.abs(closest - this.targetFrame)
                ? current
                : closest
            );
          }
          if (frameIndex === this.drawnFrame) return;
          const image = this.frames[frameIndex];
          const width = this.canvas.width;
          const height = this.canvas.height;
          const scale = this.fit === 'cover'
            ? Math.max(width / image.naturalWidth, height / image.naturalHeight)
            : Math.min(width / image.naturalWidth, height / image.naturalHeight);
          const drawWidth = image.naturalWidth * scale;
          const drawHeight = image.naturalHeight * scale;
          const x = (width - drawWidth) / 2;
          const y = (height - drawHeight) / 2;
          this.context.clearRect(0, 0, width, height);
          this.context.drawImage(image, x, y, drawWidth, drawHeight);
          this.drawnFrame = frameIndex;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
